import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SendingEmailService {

	constructor(private http: HttpClient) { }
	getSendingEmail(body) {
		return this.http.post(`${environment.apiUrl}/trackvision/sendEmail/send`, body, {
				headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
			});
	}
}
